<ng-container [formGroup]="dateTimeControl">
  <dx-date-box
    class="date-picker dx-date-box-overrides"
    [class.date-picker-is-action]="isActionControl"
    [class.dx-date-box-overrides-without-padding]="isActionControl"
    formControlName="date"
    [type]="dateBoxTypes.DATE"
    [placeholder]="locale.date"
    [showClearButton]="!!clearButton.date"
    [useMaskBehavior]="true"
    [displayFormat]="dateFormat"
    [dateSerializationFormat]="dateFormat"
    [disabledDates]="disableUnsuitableDates"
    (onOpened)="opened($event)"
  ></dx-date-box>

  <dx-date-box
    *ngIf="dateTimeControl.get(dateBoxTypes.TIME)"
    class="time-picker form__time-picker dx-date-box-overrides"
    [class.time-picker-is-action]="isActionControl"
    [class.dx-date-box-overrides-without-padding]="isActionControl"
    [formControl]="$any(dateTimeControl.get(dateBoxTypes.TIME))"
    [type]="dateBoxTypes.TIME"
    [placeholder]="locale.time"
    [showClearButton]="!!clearButton.time"
    [useMaskBehavior]="true"
    [displayFormat]="timeFormat"
    [dateSerializationFormat]="timeFormat"
    (onOpened)="opened($event)"
  ></dx-date-box>
</ng-container>
